import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

export default function MagneticButton({ children, className, onClick, ariaLabel }) {
  const ref = useRef(null);
  
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  
  // Spring settings for the jelly snap-back
  const springConfig = { stiffness: 150, damping: 15, mass: 0.1 };
  const springX = useSpring(x, springConfig);
  const springY = useSpring(y, springConfig);

  // INCREASED STICKINESS: Changed from 0.3 to 0.6. 
  // Increase closer to 1.0 for extreme stretch, decrease for subtle stretch.
  const pullStrength = 0.6; 

  const handleMouseMove = (e) => {
    if (!ref.current) return;
    if (!ref.current || window.innerWidth < 768) return;
    const { clientX, clientY } = e;
    const { left, top, width, height } = ref.current.getBoundingClientRect();
    const centerX = left + width / 2;
    const centerY = top + height / 2;
    
    x.set((clientX - centerX) * pullStrength); 
    y.set((clientY - centerY) * pullStrength);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.button
      ref={ref}
      onClick={onClick}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ x: springX, y: springY }}
      className={className}
      aria-label={ariaLabel}
    >
      {children}
    </motion.button>
  );
}